import axios from "axios";
import { useEffect, useState } from "react";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import DataTable from "../../common/data-table/data-table";
import qs from "qs";
import ToggleSwitch from "../../common/toggle-switch/toggle-switch";

const Tasks = () => {
    const tableHeader = [
        { name: "", key: "toggle" },
        { name: "Task Name", key: "title", style:{maxWidth:"30ch",minWidth:"20ch"} },
        { name: "Details", key: "detail",style:{maxWidth:"30ch",minWidth:"20ch"} },
        { name: "Due Date", key: "deadlineInString" },
        { name: "Completed By", key: "completedByName" },
        { name: "Completed At", key: "completedOnString" },
        { name: "Reminder Sent", key: "isReminderSent" },
    ];
    const [tableData, setTableData] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [fetchComplete, setFetchComplete] = useState(false);
    const [taskLoading, setTaskLoading] = useState(false);
    const [taskStatusFilter, setTaskStatusFilter] = useState("ALL");

    useEffect(()=>{
        if(taskStatusFilter==="COMPLETED") {
            setDisplayData(tableData.filter(data => data.isCompleted ));
        } else if(taskStatusFilter==="INCOMPLETED") {
            setDisplayData(tableData.filter(data => !data.isCompleted ));
        } else {
            setDisplayData(tableData);
        }
    },[taskStatusFilter,tableData])

    function toggleTask(taskId, currentState) {
        setTaskLoading(true);

        let endPoint = "tasks-markTaskComplete";
        if (currentState === true) {
            endPoint = "tasks-markTaskInComplete";
        }

        //console.log("ENDPOINT", endPoint);

        var data = qs.stringify({
            taskId: taskId,
        });

        var config = {
            method: "post",
            url: dataProvider.baseUrl + endPoint,
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                setTaskLoading(false);
                //console.log("Mark Task", response);
                let data = parseTasks(response.data.allTasksData);
                setTableData(data);
            })
            .catch((error) => {
                setTaskLoading(false);
                console.error(error);
            });
    }

    function parseTasks(data) {
        let taskData = [];
        data.forEach((task) => {
            let { 
                completedByName,
                // deadline,
                desc, 
                deadlineInString, 
                title,
                taskType, 
                isCompleted, 
                completedOn, 
                isReminderSent } = task;

            let completedOnString;
            if (isCompleted && completedOn) {
                let date = new Date(completedOn._seconds * 1000);
                completedOnString =
                    date.toDateString().split(" ").slice(1).join(" ") + " - " + date.toTimeString().split(" ")[0];
            }

            let detail ;
            let detailString ;


            // let isExpired = deadline._seconds*1000 < Date.now() ;

            if(taskType === "memberLicenseExpiry") {
                detail = `License Expiry for ${task.metaData.name} ${task.metaData.licenceid}`
                detailString = detail ;
            } else {
                detail = desc ;
                detailString = desc ;
            }
            

            if (!completedOn) completedOn = "-";
            if (!completedByName) completedByName = "-";

            if (isCompleted === false) {
                completedByName = "-";
                completedOnString = "-";
            }

            taskData.push({
                completedByName,
                deadlineInString,
                title,
                detail,
                detailString,
                isReminderSent: isReminderSent ? "Yes" : "No",
                toggle: <ToggleSwitch onChange={() => toggleTask(task.id, isCompleted)} checked={isCompleted} />,
                completedOnString,
                isCompleted
            });
        });

        return taskData;
    }

    useEffect(() => {
        var config = {
            method: "get",
            url: dataProvider.baseUrl + "tasks-getTasksByOrgId",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
            },
        };

        axios(config)
            .then(function (response) {
                // console.log("Tasks", response.data);
                setFetchComplete(true);
                let data = parseTasks(response.data);
                setTableData(data);
            })
            .catch((error) => {
                setFetchComplete(true);
                console.error(error);
            });
    }, []);

    return (
        <div id="tasks">
            <div className="container-fluid p-3">
                <div className="card p-3 border-0">
                    <div className="d-flex w-100 align-items-center">
                        <h5 className="m-0">Tasks</h5>
                        {taskLoading && (
                            <div className="ms-3 spinner-border spinner-border-sm text-primary" role="status"></div>
                        )}
                        <div className="flex-fill"></div>
                        <div className="btn-group" role="group" aria-label="Basic example">
                            <button
                                type="button"
                                onClick={() => setTaskStatusFilter("ALL")}
                                className={
                                    taskStatusFilter === "ALL" ? "btn btn-primary text-light" : "btn btn-outline-gray"
                                }
                            >
                                All
                            </button>
                            <button
                                type="button"
                                onClick={() => setTaskStatusFilter("COMPLETED")}
                                className={
                                    taskStatusFilter === "COMPLETED"
                                        ? "btn btn-primary text-light"
                                        : "btn btn-outline-gray"
                                }
                            >
                                Completed
                            </button>
                            <button
                                type="button"
                                onClick={() => setTaskStatusFilter("INCOMPLETED")}
                                className={
                                    taskStatusFilter === "INCOMPLETED"
                                        ? "btn btn-primary text-light"
                                        : "btn btn-outline-gray"
                                }
                            >
                                Incomplete
                            </button>
                        </div>
                        <div className="ms-3 position-relative">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search for tasks"
                                style={{ height: "2.5rem" }}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                            <div
                                className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center"
                                style={{ width: "2.5rem", height: "2.5rem" }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                    <title>zoom-2</title>
                                    <g
                                        strokeLinecap="square"
                                        strokeLinejoin="miter"
                                        strokeWidth="2"
                                        fill="none"
                                        stroke="#ced4da"
                                        strokeMiterlimit="10"
                                    >
                                        <line x1="22" y1="22" x2="16.4" y2="16.4" stroke="#ced4da"></line>
                                        <circle cx="10" cy="10" r="9"></circle>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>

                    {fetchComplete ? (
                        <div className="mt-3 position-relative" style={{overflowY:"auto"}}>
                            <DataTable 
                                header={tableHeader} 
                                rawData={displayData} 
                                search={searchText} 
                                paginate
                            />

                            {
                                (taskLoading) && (
                                    <div className="position-absolute top-0 left-0 w-100 h-100 bg-dark" style={{zIndex:"99",opacity:'0.1',cursor:"wait"}}>

                                    </div>
                                )
                            }
                        </div>
                    ) : (
                        <div className="mt-3">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Tasks</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Tasks;
